var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "container" } }, [
    _c("iframe", {
      attrs: {
        allowfullscreen: "",
        src:
          "https://game-launcher-stage1.isoftbet.com/1796/200066?lang=en&cur=MXN&mode=0&user=mmgaptest&uid=FA256A55FE358A8C13EE2DECB572217C&token=b2a6aa9a-4cea-410b-8842-3433b40ca241"
      },
      on: { load: _vm.iframeLoaded }
    }),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "info" }, [
      _vm._v(
        "You can check keydown event listener when the browser are in fullscreen and press F11 and ESC by console log on developer tools"
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("button", { staticClass: "button" }, [
        _vm._v("Click me to fullscreen the iframe")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78474d00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78474d00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoTestComponent.vue
// module id = null
// module chunks = 